"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<span class=\"checkbox__wrapper\">\n    <svg id=\"checkbox\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 12\">\n        <title>Form 2</title>\n        <path id=\"checkbox-2\" data-name=\"checkbox\" d=\"M3.64,5.53L5.4,8.77S8.26,2.19,12.78,0c-0.11,1.57-.55,2.92.22,4.59C11,5,6.94,9.7,5.62,12A15.13,15.13,0,0,0,0,7.62Z\" fill=\"#832159\"></path>\n    </svg>\n</span>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-628402d5", module.exports)
  } else {
    hotAPI.update("_v-628402d5", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}